import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Card, CardMedia, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  productBox: {
    backgroundColor: '#f8f8f8',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(1),
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    padding: theme.spacing(2),
    textAlign: 'center',
    width: 300,
    margin: theme.spacing(2),
  },
  price: {
    fontSize: 18,
    marginTop: theme.spacing(1),
  },
  quantityContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
  quantityText: {
    fontSize: 16,
    fontWeight: 'bold',
    marginRight: theme.spacing(1),
  },
  quantityButton: {
    minWidth: 32,
  },
  purchaseButton: {
    backgroundColor: '#333',
    color: '#fff',
    border: 'none',
    padding: theme.spacing(1, 2),
    fontSize: 16,
    borderRadius: theme.spacing(1),
    cursor: 'pointer',
    marginTop: theme.spacing(2),
    '&:hover': {
      backgroundColor: '#555',
    },
  },
}));

const ProductBox = ({ imageSrc, price }) => {
  const classes = useStyles();
  const [quantity, setQuantity] = useState(1);

  const handleDecreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleIncreaseQuantity = () => {
    setQuantity(quantity + 1);
  };

  const handlePurchaseClick = () => {
    // Handle purchase logic here
    console.log('Purchase clicked!', quantity);
  };

  return (
    <Card className={classes.productBox}>
      <CardMedia component="img" src={imageSrc} alt="Product" />
      <Typography variant="h6" className={classes.price}>
        Price: ${price}
      </Typography>
      <div className={classes.quantityContainer}>
        <Typography variant="body1" className={classes.quantityText}>
          Quantity:
        </Typography>
        <Button
          variant="outlined"
          className={classes.quantityButton}
          onClick={handleDecreaseQuantity}
        >
          -
        </Button>
        <Typography variant="body1" className={classes.quantityText}>
          {quantity}
        </Typography>
        <Button
          variant="outlined"
          className={classes.quantityButton}
          onClick={handleIncreaseQuantity}
        >
          +
        </Button>
      </div>
      <Button
        className={classes.purchaseButton}
        onClick={handlePurchaseClick}
      >
        Purchase
      </Button>
    </Card>
  );
};

export default ProductBox;
